<button [matMenuTriggerFor]="menu" [ngClass]="[hasButtonBackground ? 'bg-white' : '']" mat-icon-button>
  <mat-icon>more_vert</mat-icon>
</button>

<mat-menu #menu="matMenu">
  @if (hasDetailButton) {
    <button (click)="onDetail()" mat-menu-item>
      <mat-icon>visibility</mat-icon>
      {{ 'personal_content.nibble_menu.show_details' | transloco }}
    </button>
  }

  @if (hasCopyNibbleUrlButton) {
    <button (click)="onCopyNibbleUrl()" mat-menu-item>
      <mat-icon>content_copy</mat-icon>
      {{ 'personal_content.nibble_menu.copy_url' | transloco }}
    </button>
  }

  @if (hasDownloadButton) {
    <button (click)="onDownload()" mat-menu-item>
      <mat-icon>download</mat-icon>
      {{ 'personal_content.nibble_menu.download' | transloco }}
    </button>
  }

  @if (hasModifyButton) {
    <button (click)="onModifyCrop()" mat-menu-item>
      <mat-icon>crop</mat-icon>
      {{ 'personal_content.nibble_menu.modify_crop_shape' | transloco }}
    </button>
  }

  <mat-divider></mat-divider>

  @if (hasEditNibbleButton) {
    <button (click)="onEditNibble()" mat-menu-item>
      <mat-icon>edit</mat-icon>
      {{ 'personal_content.nibble_menu.edit' | transloco }}
    </button>
  }

  @if (hasEditCollectionButton) {
    <button (click)="onEditCollection()" mat-menu-item>
      <mat-icon>edit</mat-icon>
      {{ 'personal_content.nibble_menu.edit' | transloco }}
    </button>
  }

  <mat-divider></mat-divider>

  @if (hasCopyToButton) {
    <button (click)="onCopyTo()" [disabled]="hideCollections" mat-menu-item>
      <mat-icon>content_copy</mat-icon>
      {{ 'personal_content.nibble_menu.copy_to' | transloco }}
    </button>
  }

  @if (hasMoveToButton) {
    <button (click)="onMoveTo()" [disabled]="hideCollections" mat-menu-item>
      <mat-icon>open_with</mat-icon>
      {{ 'personal_content.nibble_menu.move_to' | transloco }}
    </button>
  }

  @if (hasAddBeforeButton) {
    <button (click)="onAddBefore()" mat-menu-item>
      <mat-icon>add</mat-icon>
      {{ 'personal_content.nibble_menu.add_before' | transloco }}
    </button>
  }
  @if (hasAddAfterButton) {
    <button (click)="onAddAfter()" mat-menu-item>
      <mat-icon>add</mat-icon>
      {{ 'personal_content.nibble_menu.add_after' | transloco }}
    </button>
  }

  <mat-divider></mat-divider>

  @if (hasRemoveButton) {
    <button (click)="onRemove()"
      [disabled]="!nibbleCut.nibble.relations.ownedByCurrentUser && !collection.relations.ownedByCurrentUser"
      mat-menu-item>
      <mat-icon>{{ isFavorites ? 'star' : 'delete' }}</mat-icon>
      {{ (isFavorites ? 'personal_content.nibble_menu.remove_from_favorites' : 'personal_content.nibble_menu.remove') | transloco }}
    </button>
  }
</mat-menu>
